import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Popover, usePopover } from '@awaze/design-system.components.popover';
import { getGaAttribute } from '../utils/ga-attribute';
import { NavigationItem } from './navigation-item';
import { NavigationItemText } from './navigation-item-text';
import { NavigationItemStyled } from './navigation-item.styles';
const SubmenuTitleStyled = styled.li `
  p {
    color: ${({ theme }) => theme.ColorGrey900};
    font-weight: ${({ theme }) => theme.FontTextText300BoldFontWeight};
    padding: 6px 0;
    margin: 0 0 12px;
    max-width: 300px;
    overflow-wrap: break-word;
    white-space: normal;
  }
`;
export const PopoverDropdownStyled = styled.div `
  transition: opacity 150ms ease;
  position: absolute;
  padding: 20px 0;
  width: 100%;
  white-space: nowrap;

  ${({ isOpen }) => !isOpen &&
    `
    opacity:0;
    user-select: none;
    pointer-events: none;
  `}

  // Submenu title top-padding all but first
  ${SubmenuTitleStyled} {
    &:nth-child(n + 2) {
      padding-top: 24px;
    }
  }
`;
export const NavigationItemWithPopover = (props) => {
    const { PopoverContainer, openPopover, closePopover, popoverProps, triggerProps, } = usePopover();
    const { highlight = false, isMobile, icon = null, enableMobileLoginIcon, subMenu, brand, isChild, user, link, linkPosition = 0, } = props;
    const getTitleText = (subNavItem) => {
        const showEmail = subNavItem.showUserEmail && !!user?.email;
        return showEmail ? user?.email : subNavItem.title;
    };
    return (_jsx(NavigationItemStyled, { isChild: isChild, highlight: highlight, "aria-label": highlight ? 'promoted' : null, menuItems: subMenu, "data-ga": getGaAttribute('navigationlink', link?.displayText ?? '', link?.href, linkPosition), children: _jsx("div", { onMouseLeave: closePopover, onMouseOver: openPopover, ...triggerProps, children: _jsxs(PopoverContainer, { permanent: true, children: [_jsx(NavigationItemText, { user,
                        highlight,
                        isMobile,
                        enableMobileLoginIcon,
                        link,
                        brand,
                        icon, isDropdown: true }), _jsx(PopoverDropdownStyled, { isOpen: popoverProps.popoverVisible, "aria-hidden": !popoverProps.popoverVisible, "data-testid": "popover-dropdown", children: _jsx(Popover, { enableHitarea: true, placement: "bottom", disableFlip: true, ...popoverProps, popoverVisible: true, boxConfig: { padding: 24 }, offset: { left: -40, top: 40 }, children: _jsx("ul", { children: subMenu.map((subNavItem) => (_jsxs(React.Fragment, { children: [!!getTitleText(subNavItem) && (_jsx(SubmenuTitleStyled, { children: _jsx("p", { children: getTitleText(subNavItem) }) })), _jsx(NavigationItem, { brand: brand, isChild: true, dataGa: getGaAttribute('navigationlink', subNavItem.link.displayText, subNavItem.link.href, linkPosition), ...subNavItem })] }, subNavItem.id))) }) }) })] }) }) }));
};
//# sourceMappingURL=navigation-item-with-popover.js.map